import { useNavigate } from 'react-router-dom';
import { useUnits } from '../units';

/** SCO-13 — only rendered when the user belongs to more than one unit. */
export function UnitSwitcher() {
  const { units, currentUnit, setCurrentUnitId } = useUnits();
  const navigate = useNavigate();

  if (units.length <= 1) {
    return currentUnit ? <span className="unit-name">{currentUnit.name}</span> : null;
  }

  return (
    <select
      className="unit-switcher"
      value={currentUnit?.id ?? ''}
      onChange={(e) => {
        setCurrentUnitId(e.target.value);
        navigate('/');
      }}
      aria-label="Current unit"
    >
      {units.map((u) => (
        <option key={u.id} value={u.id}>
          {u.name}
        </option>
      ))}
    </select>
  );
}
